import React, { useEffect, useState } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { Snackbar } from '@material-ui/core';
import ClassNames from 'classnames';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import Alert from '@material-ui/lab/Alert';
import { addToCartGA, trackingAddedToCartGA } from 'spwa-ui-library/esm/utils/helperGA';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { useIntl } from 'react-intl';
import SearchEmptyContainer from './SearchEmptyContainer';
import SearchNotFoundContainer from './SearchNotFoundContainer';
import ProductTile from '../../components/ProductTile';
import css from './index.module.scss';
import { useLocation, useNavigate } from '@reach/router';
import ProductCustomizationDialog from '../../components/ProductTileList/ProductCustomizationDialog';
import BundleGroupDialog from '../../components/ProductTileList/BundleGroupDialog';
import Loader from '../../components/Loader';

const { useSelector, useDispatch } = Redux;
const {
  selectProductEntities,

  getProductInfo,
} = Slices.productSlice;
const { sendLocalCart } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectCountryValidations, getClusterId } = Slices.configSlice;
const { selectPreviouslyOrderedProducts } = Slices.orderSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { addProductToCustomize } = Slices.tempCartSlice;

function SearchResultList({ products, setPageLoader, searchString, searchTerm }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationSearch = new URLSearchParams(location.search);
  const productsMap = useSelector(selectProductEntities);
  const categories = useSelector((state) => state.category);
  const address = useSelector(selectDefaultAddress);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const currentCountry = useSelector(selectCurrentCountry);
  const [showBundleGroupDialog, setShowBundleGroupDialog] = useState(0);
  const [showCustomizeProductDialog, setShowCustomizeProductDialog] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, currentCountry)
  );
  const clusterId = useSelector(getClusterId);

  const previouslyOrderedProducts = useSelector(selectPreviouslyOrderedProducts);
  let previouslyOrderedProductsId = previouslyOrderedProducts;
  previouslyOrderedProductsId = previouslyOrderedProductsId.filter(
    (value, index) => previouslyOrderedProducts?.indexOf(value) === index
  );

  useEffect(() => {
    setTimeout(() => {
      const yHeightScroll = localStorage.getItem('yHeightScroll');
      if (yHeightScroll) {
        window.scrollBy(0, yHeightScroll);
        localStorage.removeItem('yHeightScroll');
      }
    }, 100);
  }, []);

  const itemList = products.map((product) => product.id);

  const addtoCart = (prod, mapKey) => {
    setPageLoader(true);
    const category = categories?.entities?.[prod?.categories?.[0]];
    dispatch(
      sendLocalCart({
        productType: prod.bundleTypeId,
        updatedOn: new Date().getTime(),
        mainProductId: prod.id,
        // data: { ...prod, items: productsMap[prod.id].items, category: category.id },
        data: { ...prod, items: null, category: prod?.categories?.[0] },
      })
    );

    setTimeout(() => {
      setPageLoader(false);
    }, 0);
    addToCartGA(prod, countryValidations.currency, prod?.name || '', 'ProductListPage');
    trackingAddedToCartGA(prod, countryValidations.currency, category?.name || '', address);
  };

  if (!itemList.length && !searchTerm) {
    return <SearchEmptyContainer />;
  }

  if (!itemList.length && searchTerm) {
    return <SearchNotFoundContainer />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleBundleGroupAction = (optionId) => {
    setPageLoader(true);
    setIsLoading(true);
    setShowBundleGroupDialog(0);
    const category = categories?.entities?.[productsMap[showBundleGroupDialog]?.categories?.[0]];
    let productRoute = generateProductRoute({
      product: productsMap[showBundleGroupDialog],
      category,
      locale: intl.locale.toLowerCase(),
    });
    productRoute = `${productRoute}/bundle?bundleGroup=1&option=${optionId}`;

    if (locationSearch.has('cartId')) {
      productRoute = `${productRoute}&cartId=${locationSearch.get('cartId')}`;
    }

    dispatch(
      getProductInfo({
        id: showBundleGroupDialog,
        cluster: clusterId,
        service: address?.addressSubType || 'DELIVERY',
        categoryId: productsMap[showBundleGroupDialog]?.categories?.[0] || category?.id,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((resp) => {
      let selectedProductItem = resp.payload?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo['sel1Value'] == optionId;
      });

      if (!selectedProductItem?.id) {
        selectedProductItem = productsMap[selectedProductItem];
      }
      dispatch(
        getProductInfo({
          id: selectedProductItem?.id,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productsMap[showBundleGroupDialog]?.categories?.[0] || category?.id,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then(() => {
        console.log(`navigating`);
        setIsLoading(false);
        navigate(productRoute, {
          state: {
            retUrl: `${window.location.pathname}${window.location?.search || ''}`,
          },
        });
        dispatch(
          addProductToCustomize({
            productType: 'bundle',
            updatedOn: new Date().getTime(),
            mainProductId: productsMap[showBundleGroupDialog],
            data: {
              ...productsMap[optionId],
              id: showBundleGroupDialog,
              category: productsMap[showBundleGroupDialog]?.categories[0],
              noIncrement: true,
            },
          })
        );
      });
    });
  };

  return (
    <>
      <Loader shadow />
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <div className={ClassNames(css.root)}>
        <div className={css.productSearchTileWrap}>
          {itemList &&
            itemList.length > 0 &&
            itemList.map((productItem, key) => {
              const category = categories?.entities?.[productsMap[productItem]?.categories?.[0]];
              const proID = productItem;
              const productCat = category;

              const product = productsMap[proID];

              // IF NO PRODUCT SELECTED
              if (!product) {
                return null;
              }

              let isPreviouslyOrdered = previouslyOrderedProductsId?.indexOf(product.id) > -1;

              if (product?.bundleTypeId == 'bundle_group') {
                let itemIds =
                  product?.items?.map((item) => (item?.id ? parseInt(item.id) : parseInt(item))) ||
                  [];
                if (previouslyOrderedProductsId.some((item) => itemIds.includes(parseInt(item)))) {
                  isPreviouslyOrdered = true;
                }
              }

              return (
                <ProductTile
                  key={product?.name + key}
                  category={productCat || {}}
                  setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                  setShowBundleGroupDialog={
                    product?.bundleTypeId == 'bundle_group' || product?.typeId == 'bundle_group'
                      ? setShowBundleGroupDialog
                      : null
                  }
                  onAddCart={addtoCart}
                  isPreviouslyOrdered={isPreviouslyOrdered}
                  productObj={product}
                  position={'MainITEM' + key}
                  returnURL={`/${intl.locale}/search`}
                  priceTo={
                    product?.tempPrice
                      ? decimalChecker(product?.tempPrice || 0)
                      : decimalChecker(product?.originalPrice || 0)
                  }
                />
              );
            })}
        </div>
      </div>
      {showCustomizeProductDialog && (
        <ProductCustomizationDialog
          setShowCustomizeProductDialog={setShowCustomizeProductDialog}
          showCustomizeProductDialog={showCustomizeProductDialog}
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          oldLocation={JSON.parse(JSON.stringify(location))}
          returnURL={`/${intl.locale}/search`}
        />
      )}
      {showCustomizeProductDialog && (
        <BundleGroupDialog
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          showBundleGroupDialog={showBundleGroupDialog}
          handleBundleGroupAction={handleBundleGroupAction}
        />
      )}
    </>
  );
}

export default SearchResultList;
